/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class HttpCallsCountService {
  private httpCallCounter = 0;
  private showLoadingBar: Subject<boolean> = new Subject<boolean>();

  increaseCallsCounter() {
    this.httpCallCounter++;
    this.showLoadingBar.next(true);
  }

  decreaseCallsCounter() {
    this.httpCallCounter--;
    if (this.httpCallCounter == 0) {
      this.showLoadingBar.next(false);
    }
  }

  public isShowLoadingBar(): Subject<boolean> {
    return this.showLoadingBar;
  }
}
